import React, { PureComponent } from 'react';
import { Form } from 'semantic-ui-react';
import { reduxForm, Field } from 'redux-form';
import { SemanticFormField } from './SemanticFormField';
import { getValidations } from '../helpers/validationByFieldType';

// components

class ConfirmAuthorization extends PureComponent {

  componentDidMount() {
    const isGermanShore =
      process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    if (isGermanShore) {
      this.props.change('confirmAuthorization', true);
      this.props.touch('confirmAuthorization');
    }
  }


  render() {

    const isGermanShore =
      process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    return (
      <Form
        style={{
          visibility: isGermanShore ? 'hidden' : 'visible',
          height: isGermanShore ? 0 : 'auto',
          overflow: 'hidden',
        }}>
        <Field
          name="confirmAuthorization"
          label="Ich bestätige die Autorisierung:"
          component={SemanticFormField}
          as={Form.Checkbox}
          validate={getValidations(true)}
        />
      </Form>
    );
  }
}

export default reduxForm({ form: 'confirmAuthorizationForm', destroyOnUnmount: false })(ConfirmAuthorization);



// WEBPACK FOOTER //
// ./src/components/ConfirmAuthorization.js